const RankTags = ({ acoes }) => {
    
    const tags = acoes
    .filter((a) => a.tipo_acao === "filtrar" && a.tag)
    .reduce((acc, cur) => {
        acc[cur.tag] = (acc[cur.tag] || 0) + 1;
        return acc;
    }, {});
    
    const ranking = Object.entries(tags)
    .sort((a, b) => b[1] - a[1])
    .map(([tag, total]) => ({ tag, total }));
    
    const totalMax = ranking.length > 0 ? ranking[0].total : 0;
    
    return (
      <div className="bg-white rounded-2xl shadow p-4">
        <h3 className="text-sm font-semibold text-gray-600 mb-3">
          Tags mais usadas
        </h3>
        <ul className="space-y-2">
          {ranking.slice(0, 6).map(({ tag, total }) => (
            <li key={tag}>
              <div className="flex justify-between text-sm text-gray-700 font-medium">
                <span>{tag}</span>
                <span>{total}</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2.5 mt-1">
                <div
                  className="bg-indigo-500 h-2.5 rounded-full"
                  style={{ width: `${(total / totalMax) * 100}%` }}
                ></div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    );
  };
  export default RankTags;
  